import React, { Component } from 'react'
import app from '../feathers'
import { getAuthenticatedImage } from '../lib'
import { Spinner } from 'react-mdl'

/**
 * Returns an image DOM node, handles the image authentication and loading spinner display.
 * @memberof components
 **/
class AuthenticatedImage extends Component {
  state = {
    loading: true,
    source: null,
  }
  shouldSetImage = true
  async componentDidMount() {
    const { source } = this.props
    this.updateImage(source)
  }
  async componentWillReceiveProps({ source }) {
    if (this.props.source !== source) {
      this.updateImage(source)
    }
  }
  componentWillUnmount() {
    this.shouldSetImage = false
  }
  updateImage = async imageSource => {
    const token = await app.passport.getJWT()
    const source = await getAuthenticatedImage(imageSource, token)
    if (!this.shouldSetImage) return
    this.setState({
      loading: false,
      source,
    })
  }
  render() {
    // eslint-disable-next-line no-unused-vars
    const { source: _, ...restProps } = this.props
    const { loading, source } = this.state
    if (loading) {
      return (
        <div>
          <Spinner />
        </div>
      )
    }
    return <img src={source} alt="" {...restProps} />
  }
}

export default AuthenticatedImage



// WEBPACK FOOTER //
// ./src/components/AuthenticatedImage.js